import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "candidate-info",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "candidateinfo" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [],
});
